module.exports = __webpack_public_path__ + "static/img/CloseBtn.064cb4b9.svg";